var $62f9bc1f98ea21de$exports = {};
$62f9bc1f98ea21de$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecteer een item`,
    "tableResizer": `Resizer`
};


export {$62f9bc1f98ea21de$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
